export const currentGroup = state => state.groups.currentGroup

export const groups = state => state.groups.list
